/* eslint-disable import/no-named-as-default-member */
import React from 'react'
import { connect } from 'react-redux'
import { Label, List, Popup, Button, Icon, Header, Table, Divider } from 'semantic-ui-react'
import _ from 'lodash'
import moment from 'moment'
import firebase from '../../../config/firebase'

import RestaurantActions from '../../../reducers/restaurantReducer'

import Placeholder from './storePlaceholder'
import BranchForm from '../forms/branchForm'
import TemporaryCloseForm from '../forms/temporaryClosedForm'
import LinkDynamicFeeForm from '../forms/dynamicFeeForm'
import VendorInfoForm from '../forms/vendorInfoForm'
import VendorInfoButton from './vendorInfoButton'

const initBranchData = {
  name: '',
  address: '',
  lat: 0,
  lng: 0,
  commission_rate: 0,
  order_phone: '',
  manager_phone: '',
  monthly_report: false,
  accept_online_payment: true,
  merchant_settlement: false,
  merchant_settlement_type: 'net',
  aba_account_name: '',
  aba_account_number: '',
  operation_type: 'App',
  schedules: {
    monday: { from: '0:00', to: '0:00' },
    tuesday: { from: '0:00', to: '0:00' },
    wednesday: { from: '0:00', to: '0:00' },
    thursday: { from: '0:00', to: '0:00' },
    friday: { from: '0:00', to: '0:00' },
    saturday: { from: '0:00', to: '0:00' },
    sunday: { from: '0:00', to: '0:00' },
  },
}

class BranchesSummary extends React.PureComponent {
  state = {
    branchData: null,
    feeData: null,
    modalVisible: false,
    temporaryModalVisible: false,
    vendorInfoModalVisible: false,
    dynamicFeeModalVisible: false,
    editDynamicFeeModalVisible: false,
    action: null,
  }

  onDeleteClick = branch => {
    const { storeId, deleteBranch } = this.props

    const confirm = window.confirm(`Are you sure to delete (${branch.name || 'Unknown'}) branch?`)

    if (confirm) {
      deleteBranch(storeId, branch)
    }
  }

  onEditClick = branch => {
    this.setState({
      modalVisible: true,
      branchData: { ...initBranchData, ...branch },
      action: 'edit',
    })
  }

  onAddClick = () => {
    this.setState({ modalVisible: true, branchData: initBranchData, action: 'new' })
  }

  onTemporaryClick = branch => {
    this.setState({ temporaryModalVisible: true, branchData: branch })
  }

  onVendorInfoClick = branch => {
    this.setState({ vendorInfoModalVisible: true, branchData: branch })
  }

  onDynamicFeeClick = branch => {
    this.setState({ dynamicFeeModalVisible: true, branchData: branch })
  }

  onEditDynamicFee = (fee, branch) => {
    this.setState({ editDynamicFeeModalVisible: true, branchData: branch, feeData: fee })
  }

  onClose = () => {
    this.setState({
      action: null,
      branchData: null,
      feeData: null,
      modalVisible: false,
      temporaryModalVisible: false,
      vendorInfoModalVisible: false,
      dynamicFeeModalVisible: false,
      editDynamicFeeModalVisible: false,
    })
  }

  onFieldChange = (field, value) => {
    let { branchData } = this.state

    branchData = {
      ...branchData,
      [field]: value,
    }

    this.setState({ branchData })
  }

  onSaveBranch = () => {
    const { action, branchData } = this.state
    const { storeId, saveBranch } = this.props
    let branchId

    if (action === 'edit') {
      branchId = branchData.key
    } else {
      branchId = firebase
        .database()
        .ref(`restaurants/${storeId}/branches`)
        .push().key
    }

    saveBranch(storeId, branchId, branchData, () => {
      this.onClose()
    })
  }

  onMapClick = ({ lat, lng }) => {
    const maps = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
    window.open(maps)
  }

  workingHour = (schedules = {}, day) => {
    const workingHour = schedules[day]

    if (workingHour === undefined) {
      return 'Closed'
    }
    return `${workingHour.from} - ${workingHour.to}`
  }

  renderLoading = () => <Placeholder />

  renderTemporaryClose = (temporaryClosed, branch) => {
    return (
      <Popup
        on="hover"
        trigger={
          <Button
            icon
            color={temporaryClosed ? 'red' : 'black'}
            size="mini"
            onClick={() => this.onTemporaryClick(branch)}
          >
            {temporaryClosed ? 'Temporary Closed Set' : 'Set Temporary Close'}
          </Button>
        }
      >
        {temporaryClosed ? (
          <div>
            Start Date : {moment(parseInt(temporaryClosed.start_at, 10)).format('DD-MMM-YYYY')}
            <br />
            End Date : {moment(parseInt(temporaryClosed.end_at, 10)).format('DD-MMM-YYYY')}
          </div>
        ) : (
          <div>There is no data</div>
        )}
      </Popup>
    )
  }

  renderBranchDynamicsFee = branch => {
    return _.map(branch.dynamic_fees || {}, (fee, feeKey) => {
      return (
        <Popup
          key={feeKey}
          on="hover"
          trigger={
            <Button
              key={feeKey}
              color={!fee.active ? 'red' : 'black'}
              size="mini"
              style={{ marginBottom: 6 }}
              onClick={() => this.onEditDynamicFee({ ...fee, key: feeKey }, branch)}
            >
              {fee.name}
            </Button>
          }
        >
          <div style={{ marginBottom: 6 }}>
            Type:
            <Label style={{ marginLeft: 5 }} color="orange">
              {fee.type} ({fee.type === 'FIXED' ? `$ ${fee.fee_amount}` : `${fee.fee_rate} %`})
            </Label>
          </div>
          <div style={{ marginBottom: 6 }}>
            Go to: <Label style={{ marginLeft: 5 }}>{fee.go_to}</Label>
          </div>
          <div />
        </Popup>
      )
    })
  }

  renderBranches = () => {
    let { branches } = this.props

    branches = _.map(branches, (branch, branchKey) => ({
      ...branch,
      key: branchKey,
    }))

    branches = _.orderBy(branches, ['created_at', 'modified_at'], ['desc', 'desc'])

    return _.map(branches, (branch, index) => {
      const temporaryClosed = branch.temporary_closed

      return (
        <React.Fragment key={index}>
          {index > 0 && (
            <Table.Row>
              <Table.Cell colSpan={4}>
                <Divider style={{ margin: 0 }} />
              </Table.Cell>
            </Table.Row>
          )}
          <Table.Row>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Name:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>
              <Popup
                style={{ maxWidth: 400 }}
                trigger={<span>{branch.name}</span>}
                content={`UID: ${branch.key}`}
                on="click"
                hideOnScroll
              />
              <Icon
                size="large"
                name="map"
                color="green"
                style={{ cursor: 'pointer', marginLeft: 10 }}
                onClick={() => this.onMapClick(branch)}
              />
            </Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Operation Type:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.operation_type}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Latitude:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.lat}</Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Longitude:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.lng}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Order Phone:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.order_phone || 'No Number'}</Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Manager Phone:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.manager_phone || 'No Number'}</Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Address:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.address || '...'}</Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Full or Net:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{_.capitalize(branch.merchant_settlement_type || 'net')}</Table.Cell>
          </Table.Row>

          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Online Payment:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>
              {branch.accept_online_payment ? 'Accepted' : 'No'}
            </Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Pay Later:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.merchant_settlement ? 'Accepted' : 'No'}</Table.Cell>
          </Table.Row>

          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold', paddingTop: 15 }}>ABA Account Name:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.aba_account_name ? branch.aba_account_name : '-/-'}</Table.Cell>

            <Table.Cell style={{ width: '15%', fontWeight: 'bold', paddingTop: 15 }}>Vendor Info:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>
              <VendorInfoButton
                vendorData={branch}
                onClick={() => this.onVendorInfoClick(branch)}
              />
            </Table.Cell>
          </Table.Row>

          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold', paddingTop: 15 }}>ABA Account Number:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.aba_account_name ? branch.aba_account_number : '-/-'}</Table.Cell>

            <Table.Cell style={{ width: '15%', fontWeight: 'bold', paddingTop: 15 }}>
              Dynamic Fees:
            </Table.Cell>
            <Table.Cell style={{ width: '35%' }}>
              <div style={{ marginRight: 5 }}>{this.renderBranchDynamicsFee(branch)}</div>
              <Button size="mini" onClick={() => this.onDynamicFeeClick(branch)}>
                Link Dynamic Fee
              </Button>
            </Table.Cell>
          </Table.Row>
          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold', paddingTop: 15 }}>Commission Rate:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.commission_rate || 0}%</Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Monthly Report:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{branch.monthly_report ? 'Yes' : 'No'}</Table.Cell>
          </Table.Row>

          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Schedules:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>
              <List bulleted>
                <List.Item>
                  Monday: {branch.schedules && this.workingHour(branch.schedules, 'monday')}
                </List.Item>
                <List.Item>
                  Tuesday: {branch.schedules && this.workingHour(branch.schedules, 'tuesday')}
                </List.Item>
                <List.Item>
                  Wednesday:
                  {branch.schedules && this.workingHour(branch.schedules, 'wednesday')}
                </List.Item>
                <List.Item>
                  Thursday: {branch.schedules && this.workingHour(branch.schedules, 'thursday')}
                </List.Item>
                <List.Item>
                  Friday: {branch.schedules && this.workingHour(branch.schedules, 'friday')}
                </List.Item>
                <List.Item>
                  Saturday: {branch.schedules && this.workingHour(branch.schedules, 'saturday')}
                </List.Item>
                <List.Item>
                  Sunday: {branch.schedules && this.workingHour(branch.schedules, 'sunday')}
                </List.Item>
              </List>
            </Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.Cell colSpan={4} style={{ paddingBottom: 0 }}>
              <Button icon color="red" onClick={() => this.onDeleteClick(branch)} size="mini">
                <Icon name="trash" /> Delete
              </Button>
              <Button icon color="black" onClick={() => this.onEditClick(branch)} size="mini">
                <Icon name="edit" /> Edit
              </Button>

              {this.renderTemporaryClose(temporaryClosed, branch)}
            </Table.Cell>
          </Table.Row>
        </React.Fragment>
      )
    })
  }

  renderNoBranches = () => {
    return (
      <Table.Row>
        <Table.Cell colSpan={4} textAlign="center" style={{ padding: 40 }}>
          <Header size="small">No data available</Header>
        </Table.Cell>
      </Table.Row>
    )
  }

  renderSummary = () => {
    const { branches, branchLoading, storeId, dynamicFees, permissions } = this.props
    const {
      action,
      branchData,
      feeData,
      modalVisible,
      temporaryModalVisible,
      vendorInfoModalVisible,
      dynamicFeeModalVisible,
      editDynamicFeeModalVisible,
    } = this.state

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0px 14px',
          }}
        >
          <div style={{ display: 'flex' }}>
            <Header>Branches ({_.size(branches)})</Header>
          </div>
          <div style={{ display: 'flex' }}>
            <Button icon color="black" onClick={this.onAddClick}>
              <Icon name="add" /> Add New Branch
            </Button>
          </div>
        </div>
        <div>
          <Divider style={{ margin: 14 }} />
        </div>
        <div style={{ display: 'flex', flex: 1, overflow: 'auto' }} className="branches-summary">
          <Table className="no-border" style={{ fontSize: 16 }}>
            <Table.Body>{_.size(branches) > 0 ? this.renderBranches() : this.renderNoBranches()}</Table.Body>
          </Table>
        </div>
        {branchData && (
          <BranchForm
            permissions={permissions}
            loading={branchLoading}
            visible={modalVisible}
            branchData={branchData}
            onClose={this.onClose}
            action={action}
            onFieldChange={this.onFieldChange}
            saveBranch={this.onSaveBranch}
          />
        )}
        {branchData && (
          <TemporaryCloseForm
            storeId={storeId}
            branch={branchData}
            visible={temporaryModalVisible}
            onClose={this.onClose}
          />
        )}
        {branchData && (
          <VendorInfoForm
            storeId={storeId}
            actionType="branch"
            onClose={this.onClose}
            vendorData={branchData}
            visible={vendorInfoModalVisible}
          />
        )}
        {branchData && dynamicFeeModalVisible && (
          <LinkDynamicFeeForm
            storeId={storeId}
            branch={branchData}
            visible={dynamicFeeModalVisible}
            onClose={this.onClose}
            dynamicFees={dynamicFees}
          />
        )}
        {branchData && editDynamicFeeModalVisible && (
          <LinkDynamicFeeForm
            action="edit"
            storeId={storeId}
            branch={branchData}
            visible={editDynamicFeeModalVisible}
            onClose={this.onClose}
            dynamicFees={dynamicFees}
            feeData={feeData}
          />
        )}
      </div>
    )
  }

  render() {
    const { branches, loading } = this.props

    if (loading || !branches) {
      return this.renderLoading()
    }

    if (branches) {
      return this.renderSummary()
    }

    return null
  }
}

const mapStateToProps = ({ restaurants, dynamicFees, rolePermission, auth }) => ({
  branchLoading: restaurants.branchLoading,
  dynamicFees: dynamicFees.dynamicFees,
  permissions: rolePermission.roles[auth.data.role].access,
})

const mapDispatchToProps = {
  saveBranch: RestaurantActions.saveBranch,
  deleteBranch: RestaurantActions.deleteBranch,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BranchesSummary)



// WEBPACK FOOTER //
// ./src/components/restaurants/views/branchesSummary.js